/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbClasseHoraireRemplacementDto,
  FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults,
  FilterCriteriaInfo,
  RechercheClasseHoraireRemplacementOccasionnelSearch,
  SelectItem,
} from '../models/index';
import {
    FcbClasseHoraireRemplacementDtoFromJSON,
    FcbClasseHoraireRemplacementDtoToJSON,
    FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResultsFromJSON,
    FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    RechercheClasseHoraireRemplacementOccasionnelSearchFromJSON,
    RechercheClasseHoraireRemplacementOccasionnelSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface RemplacementOccasionnelBaseSearchRequest {
    RechercheClasseHoraireRemplacementOccasionnelSearch?: RechercheClasseHoraireRemplacementOccasionnelSearch;
}

export interface RemplacementOccasionnelGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface RemplacementOccasionnelGetSelectItemsRequest {
    searchField: string;
}

export interface RemplacementOccasionnelSaveRequest {
    FcbClasseHoraireRemplacementDto?: FcbClasseHoraireRemplacementDto;
}

/**
 * 
 */
export class RemplacementOccasionnelApi extends runtime.BaseAPI {

    /**
     */
    async remplacementOccasionnelBaseSearchRaw(requestParameters: RemplacementOccasionnelBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/RemplacementOccasionnel/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RechercheClasseHoraireRemplacementOccasionnelSearchToJSON(requestParameters.RechercheClasseHoraireRemplacementOccasionnelSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async remplacementOccasionnelBaseSearch(requestParameters: RemplacementOccasionnelBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults> {
        const response = await this.remplacementOccasionnelBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async remplacementOccasionnelGetSearchCriteriasRaw(requestParameters: RemplacementOccasionnelGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/RemplacementOccasionnel/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async remplacementOccasionnelGetSearchCriterias(requestParameters: RemplacementOccasionnelGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.remplacementOccasionnelGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async remplacementOccasionnelGetSelectItemsRaw(requestParameters: RemplacementOccasionnelGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling remplacementOccasionnelGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/RemplacementOccasionnel/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async remplacementOccasionnelGetSelectItems(requestParameters: RemplacementOccasionnelGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.remplacementOccasionnelGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async remplacementOccasionnelSaveRaw(requestParameters: RemplacementOccasionnelSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbClasseHoraireRemplacementDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/RemplacementOccasionnel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FcbClasseHoraireRemplacementDtoToJSON(requestParameters.FcbClasseHoraireRemplacementDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbClasseHoraireRemplacementDtoFromJSON(jsonValue));
    }

    /**
     */
    async remplacementOccasionnelSave(requestParameters: RemplacementOccasionnelSaveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbClasseHoraireRemplacementDto> {
        const response = await this.remplacementOccasionnelSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
